import { CALL_API } from "../api.middleware";
import {
  GET_CAMS_DATA,
  GET_CAMS_DATA_FAILED,
  GET_CAMS_DATA_SUCCESS,
  SAVE_EMPANELMENT,
  SAVE_EMPANELMENT_FAILED,
  SAVE_EMPANELMENT_SUCCESS,
  GENERATE_EMPANEL_OTP,
  GENERATE_EMPANEL_OTP_FAILED,
  GENERATE_EMPANEL_OTP_SUCCESS,
  VALIDATE_EMPANEL_OTP,
  VALIDATE_EMPANEL_OTP_FAILED,
  VALIDATE_EMPANEL_OTP_SUCCESS,
  REMOVE_CAMS_DATA,
  GET_BANK_DETAILS,
  GET_BANK_DETAILS_FAILED,
  GET_BANK_DETAILS_SUCCESS,
  AGENT_REGISTRATION,
  AGENT_REGISTRATION_SUCCESS,
  AGENT_REGISTRATION_FAILED,
  VALIDATE_ARN_CODE,
  VALIDATE_ARN_CODE_SUCCESS,
  VALIDATE_ARN_CODE_FAILED,
  STORE_BASIC_DETAILS,
  STORE_BANK_STATE,
  STORE_BANK_DETAILS,
  STORE_CAMS_DETAILS,
  STORE_EMPANELLEMENT_NOMINEE_DETAILS
} from "../types/empanelment";

export const validateArn = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/ValidateArncode_Mirae",
        method: "GET",
        types: [
          VALIDATE_ARN_CODE,
          VALIDATE_ARN_CODE_SUCCESS,
          VALIDATE_ARN_CODE_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const validatePennyDrop = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ValidatePennyDrop",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const empanelmentRegistration = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/Empanelment_AgentRegistration",
        method: "GET",
        types: [
          AGENT_REGISTRATION,
          AGENT_REGISTRATION_SUCCESS,
          AGENT_REGISTRATION_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const saveEmpanelment = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/SaveAllDetails_Empanelment",
        method: "GET",
        types: [
          SAVE_EMPANELMENT,
          SAVE_EMPANELMENT_SUCCESS,
          SAVE_EMPANELMENT_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getBankDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/GetBankByIFSCorMICR",
        method: "GET",
        types: [
          GET_BANK_DETAILS,
          GET_BANK_DETAILS_SUCCESS,
          GET_BANK_DETAILS_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCamsData = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/CAMSData",
        method: "GET",
        types: [GET_CAMS_DATA, GET_CAMS_DATA_SUCCESS, GET_CAMS_DATA_FAILED],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const generateEmpanelOTP = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/GenerateEmpanelOtp",
        method: "GET",
        types: [
          GENERATE_EMPANEL_OTP,
          GENERATE_EMPANEL_OTP_SUCCESS,
          GENERATE_EMPANEL_OTP_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const validateEmpanelOTP = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/ValidateEmpanelOtp",
        method: "GET",
        types: [
          VALIDATE_EMPANEL_OTP,
          VALIDATE_EMPANEL_OTP_SUCCESS,
          VALIDATE_EMPANEL_OTP_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCitiesList = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/GetCities",
        method: "GET",
      },
    });
  } catch (error) {
    alert(error);
  }
};

export const removeData = () => {
  return {
    type: REMOVE_CAMS_DATA,
    body: [],
  };
};

export const saveEmpanelData = (data) => {
  return {
    type: STORE_BASIC_DETAILS,
    body: data,
  };
};
export const saveCamsData = (data) => {
  return {
    type: STORE_CAMS_DETAILS,
    body: data,
  };
};
export const saveEmpanelmentNomineeData = (data) => {
  return {
    type: STORE_EMPANELLEMENT_NOMINEE_DETAILS,
    body: data,
  };
};
export const storeBankState = (data) => {
  return {
    type: STORE_BANK_STATE,
    body: data,
  };
};
export const saveBankDetails = (body) => {
  return {
    type: STORE_BANK_DETAILS,
    body,
  };
};
